import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { LoaderService } from 'src/app/shared/services/loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div *ngIf="isLoaderVisible$ | async" class="loading-overlay">
      <div class="custom-loader-spin"></div>
    </div>
  `,
  styles: [
    `
      @import '/src/styles/loader';
      .loading-overlay {
        z-index: 1056; // Needs to be on top of modals
      }
    `,
  ],
})
export class LoaderComponent {
  private readonly loaderService: LoaderService = inject(LoaderService);
  public readonly isLoaderVisible$: Observable<boolean> = this.loaderService.isLoaderVisible;
}
